<template>
    <article class="loader">
        <div class="loader-wrapper">
            <div class="loader-icon"></div>
            <p class="loader-text">{{ $t("ui.transaction.status") }}<br/> <b>{{$t("ui.transaction.refresh")}}.</b></p>
        </div>
    </article>
</template>